import React from 'react';
import { Mail, Calendar, CheckSquare, Settings } from 'lucide-react';

const WhatWeDo = () => {
  const serviceCategories = [
    {
      icon: <Mail className="h-12 w-12 text-burnt-orange" />,
      title: "Inbox & Communication Support",
      microcopy: "The goal isn't \"inbox zero.\" It's \"inbox clarity.\"",
      includes: [
        "inbox sorting + priority flags",
        "draft replies in your tone",
        "follow-ups sent on your behalf (where appropriate)",
        "client/vendor coordination messages",
        "message routing so you don't see everything"
      ]
    },
    {
      icon: <Calendar className="h-12 w-12 text-burnt-orange" />,
      title: "Calendar & Scheduling Support",
      microcopy: "Your calendar should reflect priorities—not pressure.",
      includes: [
        "scheduling across time zones",
        "meeting screening + agenda prompts",
        "calendar clean-up (protecting focus time)",
        "reminders + pre-meeting briefs",
        "reschedules and coordination without back-and-forth"
      ]
    },
    {
      icon: <CheckSquare className="h-12 w-12 text-burnt-orange" />,
      title: "Follow-Through & Task Management",
      microcopy: "Things shouldn't fall apart because you got busy.",
      includes: [
        "daily/weekly task tracking",
        "reminders and accountability loops",
        "progress updates without you chasing",
        "documentation and checklists",
        "recurring ops routines (weekly reports, admin runs)"
      ]
    },
    {
      icon: <Settings className="h-12 w-12 text-burnt-orange" />,
      title: "Ops Coordination & Admin Support",
      microcopy: "You stay in leadership mode. We keep the engine running.",
      includes: [
        "vendor coordination + scheduling",
        "document preparation and formatting",
        "research and summaries",
        "simple process setup (templates, trackers)",
        "basic project support (timelines, check-ins, next steps)"
      ]
    }
  ];

  return (
    <section id="what-we-do" className="section-padding bg-gray-50">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            Core support areas
          </h2>
        </div>

        {/* Service Categories Grid */}
        <div className="grid lg:grid-cols-2 gap-12">
          {serviceCategories.map((category, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 card-shadow animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="space-y-6">
                {/* Icon and Title */}
                <div className="space-y-4">
                  <div className="p-4 bg-burnt-orange/20 rounded-2xl w-fit">
                    {category.icon}
                  </div>
                  <div>
                    <h3 className="font-display text-2xl font-bold text-olive-brown mb-2">
                      {index + 1}) {category.title}
                    </h3>
                  </div>
                </div>

                {/* Includes */}
                <div className="space-y-4">
                  <h4 className="font-semibold text-olive-brown">Includes:</h4>
                  <div className="space-y-3">
                    {category.includes.map((item, itemIndex) => (
                      <div key={itemIndex} className="flex items-start space-x-3">
                        <div className="w-2 h-2 bg-burnt-orange rounded-full mt-2 flex-shrink-0"></div>
                        <span className="text-olive-brown/80 text-sm">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Microcopy */}
                <div className="pt-4 border-t border-olive-brown/20">
                  <p className="text-burnt-orange font-medium italic text-sm">
                    {category.microcopy}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;